<!-- this component is just to provide validation to the scenario wizard in mobile screen view -->
<script>
import { StudyArea } from "@/pages/Dashboard/Components/mixins/StudyArea";
import { ScenarioWizardHelpers } from "@/pages/Dashboard/Components/mixins/ScenarioWizardHelpers";
export default {
  name: "ScenarioStudyAreaRenderless",

  mixins: [StudyArea, ScenarioWizardHelpers],

  data() {
    return {
    };
  },

  render() {
    return this.$scopedSlots.default();
  }
};
</script>